import { DataField } from '../parametrage/structures/DataField';
import { Combo } from '../parametrage/structures/Combo';
import User from 'User';
let moment = require( 'moment');

const MULTILANG_DEFAULT_LANGUAGE = 'FR';
// Code spécial (cf. SAIStringUtils.LANGUAGE_CANCELED) : le texte complet est retourné
const MULTILANG_CANCELED_LANGUAGE = 'XX';

class StringUtils {
    static resolveTextProperties(label, contextToUse){
        if(typeof label !== 'string') {
            return label;
        }
        let context = contextToUse;
        if(context === undefined){
            context = {};
        }

        if(!label){
            return label;
        }

        var regex = /(\$(\{?(.+?)(#.+?)*\}?)(?: |$|\.(?:$| )))/g
        var matches = [];
        var curedMatches = [];

        var splittedLabel = label.split('$');
        splittedLabel.forEach(sub => {
            var subLabel = '$'+sub; // put the $ back
            var match = regex.exec(subLabel);
            while (match !== null) {
                matches.push(match[2]);
                curedMatches.push(match[0].indexOf('{') >= 0 ? match[3] : '$'+match[3]);
                match = regex.exec(subLabel);
            }
        });
        var toReplace = label;
        for(var strKey in matches){
            var toMatch = '\$'+matches[strKey];
            if(toMatch.indexOf('.') < 0) {
                if(context === undefined || context[curedMatches[strKey]] === undefined){
                    toReplace = toReplace.replace(toMatch, '');
                }else{
                    toReplace = toReplace.replace(toMatch, context[curedMatches[strKey]]);
                }
            } else {
                var splited = curedMatches[strKey].split('.');
                var root = splited[0];
                var subProp = splited[1];
                if(context === undefined || (context[curedMatches[strKey]] === undefined && (context[root] === undefined || context[root][subProp] === undefined))){
                    toReplace = toReplace.replace(toMatch, '');
                }else{

                    toReplace = toReplace.replace(toMatch, context[curedMatches[strKey]] === undefined ? context[root][subProp] : context[curedMatches[strKey]]);
                }
            }
        }
        return toReplace;
    }

    static underscoreToCamelCase(label){
        //show_select_grid will match _s and _g
        var regex = /(_.)/g;
        var matches = [];
        var match = regex.exec(label);
        while (match !== null) {
            matches.push(match[1]);
            match = regex.exec(label);
        }
        var toReplace = label;
        for(var strKey in matches){
            //replacing _s by S
            toReplace = toReplace.replace(matches[strKey], matches[strKey].substring(1,2).toUpperCase());
        }
        //show_select_grid becomes showSelectGrid
        return toReplace;
    }

    static basename(someString) {
        if(someString === undefined) {
            return someString;
        } else {
            var base = someString.substring(someString.lastIndexOf('/') + 1);
            if(base.lastIndexOf('.') != -1) {
                base = base.substring(0, base.lastIndexOf('.'));
            }
            return base;
        }
    }

    public static guid(): string {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                s4() + '-' + s4() + s4() + s4();
    }

    static formatValue(value: string, datafield: DataField, combo?: Combo, alreadyFormatted?: boolean) {
        if(value === undefined || value === '' || datafield === undefined) {
            return value;
        }

        let format = datafield.getFormat();
        let formattedValue;
        let nbDecimal = datafield.getDecimalsNumber() !== undefined ? datafield.getDecimalsNumber() : 2;
        let parsedValue;
        switch(format) {
            case 'Integer':
                formattedValue = alreadyFormatted ? value : parseInt(value).toString();
                break;
            case 'Financial':
                formattedValue = alreadyFormatted ? value : parseFloat(value).toFixed(nbDecimal).toString();
                break;
            case 'Float':
                formattedValue = alreadyFormatted ? value : parseFloat(value).toFixed(nbDecimal).toString();
                break;
            case 'Year':
                formattedValue = alreadyFormatted ? value : moment(value, 'YYYY-MM-DD HH:mm:ss').format('YYYY');
                break;
            case 'Date':
                parsedValue = moment(value, 'YYYY-MM-DD HH:mm:ss', true);
                formattedValue = parsedValue !== undefined && parsedValue.isValid() ? parsedValue.format('L') : value;
                break;
            case 'DateTime':
                parsedValue = moment(value, 'YYYY-MM-DD HH:mm:ss', true);
                formattedValue = parsedValue !== undefined && parsedValue.isValid() ? parsedValue.format('L HH:mm') : value;
                break;
            case 'Time':
                parsedValue = moment(value, 'YYYY-MM-DD HH:mm:ss', true);
                formattedValue = parsedValue !== undefined && parsedValue.isValid() ? parsedValue.format('HH:mm') : value;
                break;
            case 'Boolean':
                formattedValue = value;
                break;
            case 'Enum':
            case 'Select':
                formattedValue = this.getEnumDisplay(value, datafield, combo);
                break;
            case 'Percentage':
                let fValue = parseFloat(value) * 100;
                formattedValue = fValue.toFixed(2) + '%'
                break;
            default:
                formattedValue = value;
        }
        return this.getMultilangTextValue(User.getLocale(), formattedValue);
    }

    /**
     * Résout un texte multilingue (ex: "FR={Repas} DE={Essen}") dans la langue demandée, avec la même
     * sémantique que SAIStringUtils.getI18nFieldValue côté serveur : le texte situé hors des blocs de
     * langue est conservé (ex: "FR={Repas} - Midi" donne "Repas - Midi"), les accolades imbriquées sont
     * équilibrées et, à défaut de la langue demandée, le français puis la première langue trouvée sont
     * utilisés. Un texte sans bloc de langue est retourné tel quel.
     */
    public static getMultilangTextValue(lang: string, multilangText: string): string {
        if(typeof multilangText !== 'string' || multilangText.trim().length < 5) {
            return multilangText;
        }

        const targetLanguage = (lang || MULTILANG_DEFAULT_LANGUAGE).trim().toUpperCase();
        if(targetLanguage === MULTILANG_CANCELED_LANGUAGE) {
            return multilangText;
        }

        const values = this.getMultilangTextValues(multilangText.trim());
        if(values.size === 0) {
            return multilangText;
        } else if(values.has(targetLanguage)) {
            return values.get(targetLanguage);
        } else if(values.has(MULTILANG_DEFAULT_LANGUAGE)) {
            return values.get(MULTILANG_DEFAULT_LANGUAGE);
        }
        return values.values().next().value;
    }

    /**
     * Portage de SAIStringUtils.getI18nFieldValues : retourne, pour chaque langue trouvée, le texte
     * complet dans cette langue (texte hors blocs compris, espaces multiples réduits).
     */
    private static getMultilangTextValues(value: string): Map<string, string> {
        const content = new Map<string, string>();
        const langs = new Set<string>();
        const langPattern = /([A-Z]{2})=\{/g;
        let langMatch;
        while((langMatch = langPattern.exec(value)) !== null) {
            langs.add(langMatch[1]);
        }

        langs.forEach(lang => {
            let end = -1;
            let lastMatch = 0;
            let builder = '';
            const contentPattern = /([A-Z]{2})=\{/g;
            let contentMatch;
            while((contentMatch = contentPattern.exec(value)) !== null) {
                // Bloc imbriqué dans le précédent : déjà couvert par celui-ci
                if(end !== -1 && contentMatch.index < end) {
                    continue;
                }

                builder += value.substring(lastMatch, contentMatch.index);

                const start = contentMatch.index + contentMatch[0].length;
                end = -1;
                let balance = 0;
                for(let i = start; i < value.length && end === -1; ++i) {
                    if(value.charAt(i) === '{') {
                        ++balance;
                    } else if(value.charAt(i) === '}') {
                        if(balance === 0) { end = i; }
                        else { --balance; }
                    }
                }

                if(end === -1) {
                    console.warn('No balancing brace found in ' + value);
                    end = value.length;
                }

                lastMatch = end + 1;
                if(contentMatch[1] === lang) {
                    builder += value.substring(start, end);
                }
            }

            if(lastMatch < value.length) {
                builder += value.substring(lastMatch);
            }

            content.set(lang, builder.replace(/\s+/g, ' ').trim());
        });

        return content;
    }

    private static getEnumDisplay(enumKey: string, datafield: DataField, combo: Combo): string {
        if(!combo) {
            console.warn('Combo linked to datafield '+ datafield.getId() + ' not found, using key "' + enumKey + '" instead');
            return enumKey;
        }
        let datafieldConfig = datafield.getConfig;
        let displayCode = datafieldConfig['displayCode'];
        if(displayCode === 'CodeOnly') {
            return enumKey;
        } else if(displayCode === 'TextOnly') {
            return combo.getElement(enumKey) ? combo.getElement(enumKey).getLabel() : enumKey;
        } else {
            // Default: code + text
            let result = enumKey;
            if(combo.getElement(enumKey)) {
                result += ' - ' + combo.getElement(enumKey).getLabel();
            }
            return result
        }
    }
}

export default StringUtils;